import React, { useEffect, useRef, useState } from "react";
import { addCourseFees, getColleges, getCourseCategories, getCourses, getUniversities } from "../../Services/HomeService";
import toast from "react-hot-toast";
import HttpClientXml from "../../utils/HttpClientXml";
import moment from "moment";

const AddCourseAndFees = () => {
  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };

  const fileInputRef = useRef(null);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setCourseCategoriesLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);
  const [uploading, setUploading] = useState(false)
  const [createLoading, setCreateLoading] = useState(false);

  const initialValues = {
    type: "College", //or "University"
    universityId: "",
    collegeId: "",
    categoryId: "",
    courseDegreeId: "",
    eligibility: "",
    fees: 0,
    applicationDate: moment().format("YYYY-MM-DD"),
    brochure: "",
    courseMode: "", //online/offline
    durationYear: 0,
    durationMonth: 0
  }

  const [formData, setFormData] = useState(initialValues)

  const fetchUniversities = async () => {
    try {
      setFetchUniversitiesLoading(true);
      const res = await getUniversities();
      console.log("fetched Universities", res?.data);
      if (res?.status) {
        setUniversities(res?.data);
        setFetchUniversitiesLoading(false);
      } else {
        toast.error("Error while Fetching Universities Data");
        setFetchUniversitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Universities Data");
      console.error("Error fetching Universities:", error);
      setFetchUniversitiesLoading(false);
    }
  };

  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching Colleges Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Colleges Data");
      console.error("Error fetching Colleges:", error);
      setFetchCollegesLoading(false);
    }
  };

  const fetchCourseCategories = async () => {
    try {
      setCourseCategoriesLoading(true);
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
        setCourseCategoriesLoading(false);
      } else {
        toast.error("Error while Fetching Course Categories Data");
        setCourseCategoriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
      setCourseCategoriesLoading(false);
    }
  };

  const fetchCourses = async (categoryId) => {
    try {
      setFetchCoursesLoading(true);
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        setCourses(res?.data.filter(item => item.categoryId === categoryId));
        setFetchCoursesLoading(false);
      } else {
        toast.error("Error while Fetching Courses Data");
        setFetchCoursesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
      setFetchCoursesLoading(false);
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault()
    setUploading(true)
    const data = new FormData();
    data.append("file", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("file-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, brochure: res.image })
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false)
      fileInputRef.current.value = null;
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (
      !formData?.type ||
      !formData?.universityId ||
      !formData?.collegeId ||
      !formData?.categoryId ||
      !formData?.courseDegreeId ||
      !formData?.eligibility ||
      !formData?.fees ||
      !formData?.applicationDate ||
      !formData?.courseMode
      // !formData?.brochure
    ) {
      toast.error("Please Enter All Fields");
      return;
    }
    console.log("NHX156", formData);
    // return

    try {
      setCreateLoading(true);
      const res = await addCourseFees(formData);
      console.log("Course Fees Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setFormData(initialValues)
        setCreateLoading(false);
      } else {
        toast.error(res?.message);
        setCreateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Course Fees.");
      console.error("Error adding Course Fees:", error);
      setCreateLoading(false);
    }
  };

  useEffect(() => {
    fetchUniversities()
    fetchColleges()
    fetchCourseCategories()
  }, [])

  useEffect(() => {
    fetchCourses(formData.categoryId)
  }, [formData.categoryId])

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Add Course and Fees
          </div>
          <section className="chartBox_area">
            <form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <div className="row d-flex justify-content-center">
                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Select Type<span className="text-danger">*</span>
                  </label>
                  <select className="form-control">
                    <option value="">-------- Select Type --------</option>
                    <option value="">College</option>
                    <option value="">University</option>
                  </select>
                </div> */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Select Type<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={formData?.type}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        type: e?.target?.value,
                      }));
                    }}
                  >
                    <option value="">-------- Select Type --------</option>
                    <option value="College">College</option>
                    <option value="University">University</option>
                  </select>
                </div>
                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    University Name<span className="text-danger">*</span>
                  </label>
                  <select className="form-control">
                    <option value="">
                      -------- Select University --------
                    </option>
                    <option value="">Sikkim Manipal University</option>
                    <option value="">Swami Vivekananda University</option>
                    <option value="">
                      Maulana Abul Kalam Azad University Of Technology
                    </option>
                    <option value="">Jadhavpur University</option>
                  </select>
                </div> */}

                <div
                  className="col-md-6 mt-3"
                // style={{
                //   display:
                //     formData?.type === "College" ? "" : "none",
                // }}
                >
                  <label htmlFor="name">
                    University Name<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        universityId: e?.target?.value,
                      }));
                    }}
                    value={formData?.universityId}
                    className="form-control"
                  >
                    <option value="">
                      -------- Select University --------
                    </option>
                    {fetchUniversitiesLoading ? (
                      <option>Loading...</option>
                    ) : universities?.length === 0 ? (
                      <option>No University Found</option>
                    ) : (
                      universities.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.name}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    College Name<span className="text-danger">*</span>
                  </label>
                  <select className="form-control">
                    <option value="">-------- Select College --------</option>
                    <option value="">Lee Sun College</option>
                    <option value="">
                      Regent Education and Research Foundation
                    </option>
                    <option value="">Vivekananda College</option>
                    <option value="">Jadhavpur College</option>
                  </select>
                </div> */}
                <div
                  className="col-md-6 mt-3"
                // style={{
                //   display:
                //     formData?.type === "College" ? "" : "none",
                // }}
                >
                  <label htmlFor="name">
                    College Name<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        collegeId: e?.target?.value,
                      }));
                    }}
                    value={formData?.collegeId}
                    className="form-control"
                  >
                    <option value="">
                      -------- Select College --------
                    </option>
                    {fetchCollegesLoading ? (
                      <option>Loading...</option>
                    ) : colleges?.length === 0 ? (
                      <option>No College Found</option>
                    ) : (
                      colleges.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.name}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Course Category<span className="text-danger">*</span>
                  </label>
                  <select className="form-control">
                    <option value="">
                      -------- Select Course Category --------
                    </option>
                    <option value="">Engineering</option>
                    <option value="">Administration</option>
                    <option value="">Finance</option>
                    <option value="">Rocket Science</option>
                  </select>
                </div> */}
                <div
                  className="col-md-6 mt-3"
                // style={{
                //   display:
                //     formData?.type === "College" ? "" : "none",
                // }}
                >
                  <label htmlFor="name">
                    Course Category<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        categoryId: e?.target?.value,
                      }));
                    }}
                    value={formData?.categoryId}
                    className="form-control"
                  >
                    <option value="">
                      -------- Select Course Category --------
                    </option>
                    {fetchCourseCategoriesLoading ? (
                      <option>Loading...</option>
                    ) : courseCategories?.length === 0 ? (
                      <option>No Category Found</option>
                    ) : (
                      courseCategories.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.name}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Course Name<span className="text-danger">*</span>
                  </label>
                  <select className="form-control">
                    <option value="">
                      -------- Select Course Name --------
                    </option>
                    <option value="">Computer Engineering</option>
                    <option value="">Business Administration</option>
                    <option value=""> Finance</option>
                    <option value="">Robotics Science</option>
                  </select>
                </div> */}
                <div
                  className="col-md-6 mt-3"
                // style={{
                //   display:
                //     formData?.type === "College" ? "" : "none",
                // }}
                >
                  <label htmlFor="name">
                    Course Name<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        courseDegreeId: e?.target?.value,
                      }));
                    }}
                    value={formData?.courseDegreeId}
                    className="form-control"
                  >
                    <option value="">
                      -------- Select Course Name --------
                    </option>
                    {fetchCoursesLoading ? (
                      <option>Loading...</option>
                    ) : courses?.length === 0 ? (
                      <option>No Course Found</option>
                    ) : (
                      courses.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.degreeName}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Mode<span className="text-danger">*</span>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      gap: "30px", // spacing between radio options
                      alignItems: "center",
                      marginTop: "8px"
                    }}
                  >
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="courseMode"
                        value="offline"
                        checked={formData?.courseMode === "offline"}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            courseMode: e?.target?.value,
                          }))
                        }
                      />
                      Offline
                    </label>

                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="courseMode"
                        value="online"
                        checked={formData?.courseMode === "online"}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            courseMode: e?.target?.value,
                          }))
                        }
                      />
                      Online
                    </label>
                  </div>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Fees<span className="text-danger">*</span>
                  </label>
                  {/* <input
                    type="text"
                    id="name"
                    className="form-control"
                    value={formData?.fees}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        fees: parseInt(e?.target?.value),
                      }));
                    }}
                    placeholder="Enter Fees"
                    required
                  /> */}
                  <input
                    type="number"
                    min="0"
                    id="name"
                    className="form-control"
                    value={formData?.fees}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '') {
                        setFormData((prev) => ({
                          ...prev,
                          fees: '',
                        }));
                      } else {
                        const numericValue = parseInt(value);
                        if (!isNaN(numericValue)) {
                          setFormData((prev) => ({
                            ...prev,
                            fees: numericValue,
                          }));
                        }
                      }
                    }}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
                      ];
                      if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="Enter Fees"
                    required
                  />

                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Duration<span className="text-danger">*</span>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px", // spacing between radio options
                      alignItems: "center",
                      // marginTop: "8px"
                    }}
                  >
                    <input
                    type="number"
                    min="0"
                    name="durationYear"
                    className="form-control"
                    value={formData?.durationYear}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '') {
                        setFormData((prev) => ({
                          ...prev,
                          durationYear: '',
                        }));
                      } else {
                        const numericValue = parseInt(value);
                        if (!isNaN(numericValue)) {
                          setFormData((prev) => ({
                            ...prev,
                            durationYear: numericValue,
                          }));
                        }
                      }
                    }}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
                      ];
                      if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="Enter year"
                    // required
                  />
                  Year

                    <input
                    type="number"
                    min="0"
                    name="durationMonth"
                    className="form-control"
                    value={formData?.durationMonth}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '') {
                        setFormData((prev) => ({
                          ...prev,
                          durationMonth: '',
                        }));
                      } else {
                        const numericValue = parseInt(value);
                        if (!isNaN(numericValue)) {
                          setFormData((prev) => ({
                            ...prev,
                            durationMonth: numericValue,
                          }));
                        }
                      }
                    }}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
                      ];
                      if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="Enter month"
                    // required
                  />
                  Month
                  </div>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Eligibility<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    value={formData?.eligibility}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        eligibility: e?.target?.value,
                      }));
                    }}
                    placeholder="Eligibility"
                    required
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Applicaion Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="name"
                    className="form-control"
                    value={formData?.applicationDate}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        applicationDate: moment(e?.target?.value).format("YYYY-MM-DD"),
                      }));
                    }}
                    placeholder="Applicaion Date"
                    required
                  />
                </div>
                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Brochure<span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    id="name"
                    className="form-control"
                    value={cityName}
                    onChange={(e) => setCityName(e.target.value)}
                    placeholder="Eligibility"
                    required
                  />
                </div> */}
                <div className="col-md-12 mt-3">
                  <label htmlFor="Brochure">
                    {uploading && "Uploading "}Brochure{/*<span className="text-danger">*</span> */}
                  </label>
                  {!uploading && formData?.brochure && (
                    <>
                      {/* <img
                      src={formData?.brochure}
                      alt="Brochure Preview"
                      style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                    /> */}
                      <a href={formData?.brochure} target="_blank"
                        style={{ marginLeft: "10px" }}
                      >
                        {
                          formData?.brochure.split('.').pop().toLowerCase() === "pdf" ? <i className="fas fa-2x fa-file-pdf" /> :
                            formData?.brochure.split('.').pop().toLowerCase() === "doc" || formData?.brochure.split('.').pop().toLowerCase() === "docx" && <i className="fas fa-2x fa-file-word" />
                        }
                      </a>
                    </>
                  )}
                  <input
                    type="file"
                    ref={fileInputRef}
                    className="form-control"
                    onChange={handleFileUpload}
                    // accept="image/*,.pdf,.doc,.docx"
                    accept=".pdf,.doc,.docx"
                  // required
                  />
                </div>
              </div>
              {/* <div className=" d-flex justify-content-center">
                <button
                  type="button"
                  className="btn mt-3"
                  style={{
                    background: "#a2bae0",
                    borderRadius: "13px",
                  }}
                >
                  Add More
                </button>
              </div> */}
              <div className=" d-flex justify-content-center">
                <button
                  disabled={createLoading}
                  type="submit"
                  className="btn mt-3"
                  style={{
                    background: "rgb(133, 218, 79)",
                    borderRadius: "13px",
                  }}
                >
                  {createLoading
                    ? "Saving data..."
                    : "Add Course/Fees"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddCourseAndFees;
